import React, { ReactNode } from 'react';
import { Stack } from '@fiverr-private/layout_components';

interface MainRowProps {
    children: ReactNode;
    isFullWidth?: boolean;
    mobileWrap?: boolean;
}

export const MainRow = ({ children, isFullWidth, mobileWrap }: MainRowProps) => (
    <Stack
        display="flex"
        alignItems="center"
        justifyContent="spaceBetween"
        // When mobileWrap, reduce default gap so the row-gap between wrapped rows is 12px (spacing[3]).
        gap={mobileWrap ? { default: '3', sm: '4', lg: '8' } : { default: '9', sm: '4', lg: '8' }}
        wrap={mobileWrap ? { default: 'wrap', sm: 'nowrap' } : undefined}
        width="100%"
        height="100%"
        paddingLeft={{ default: '6', sm: '8', md: '11', lg: '5' }}
        paddingRight={{ default: '6', sm: '8', md: '11', lg: '5' }}
        maxWidth={isFullWidth ? '100%' : '1440px'}
        marginLeft="auto"
        marginRight="auto"
    >
        {children}
    </Stack>
);
